import { Box, Typography } from "@mui/joy";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { GridChildComponentProps } from "react-window";
import mockBackground from "../../../assets/background.jpg";
import { BASE_URL } from "../../../config";
import { capitalizeText } from "../../../lib/utils";
import { IQualita } from "../../../models";

const IMAGE_URL = `${BASE_URL}qualitaImage/`;

export interface IGridCellProps extends GridChildComponentProps<IQualita[][]> {
  onView: (materiale: IQualita) => void;
  columns: number;
}

export const MaterialeGridCell = ({
  columnIndex,
  rowIndex,
  style,
  data,
  onView,
  columns,
}: IGridCellProps) => {
  const { i18n } = useTranslation();
  const item = useMemo(
    () => data[rowIndex][columnIndex],
    [data, rowIndex, columnIndex]
  );
  const nome = useMemo(() => {
    if (!item) return "";
    return i18n.language === "en" && item.nomeEn ? item.nomeEn : item.nome;
  }, [item, i18n]);
  if (!item) return null;
  const background = item.image
    ? `${IMAGE_URL}${item.image.mdPath}`
    : mockBackground;
  const lastRow = data[data.length - 1];
  const filledCols = lastRow.filter(Boolean).length;
  let adjustedStyle = { ...style };
  if (rowIndex === data.length - 1 && filledCols < columns) {
    const cellWidth = (style as any).width ?? 0;
    const totalWidth = columns * cellWidth;
    const usedWidth = filledCols * cellWidth;
    const offset = (totalWidth - usedWidth) / 2;

    adjustedStyle = {
      ...style,
      left: (style as any).left + offset,
    };
  }
  const isFirst = columnIndex === 0;
  const isLast = columnIndex === columns - 1;

  return (
    <Box
      style={adjustedStyle}
      sx={{
        boxSizing: "border-box",
        position: "relative",
        cursor: "pointer",
        padding: 2,
        transition: "all 300ms ease",
        paddingLeft: isFirst ? "20px" : "16px",
        paddingRight: isLast ? "20px" : "16px",
        "&:hover": {
          transform: "translateY(-5px)",
          opacity: "0.8",
          ".bg-img": {
            transform: "scale(1.1)",
          },
        },
        "@media screen and (min-width: 1024px)": {
          paddingLeft: isFirst ? "50px" : "16px",
          paddingRight: isLast ? "50px" : "16px",
        },
      }}
      onClick={() => onView(item)}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            flex: 1,
            width: "100%",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            className="bg-img"
            sx={{
              backgroundImage: `url('${background}')`,
              transition: "all 300ms ease",
              width: "100%",
              height: "100%",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></Box>
        </Box>

        <Typography level="body-lg" sx={{ color: "rgb(86, 185, 58)" }}>
          {capitalizeText(nome)}
        </Typography>
      </Box>
    </Box>
  );
};
